import $ from 'jquery';
import ytTracker from 'youtube-google-analytics/lunametrics-youtube.gtm.js';

const externalVideos = $('[src-yt]');
let videoOnPage = false;

function callYtTracker() {
    if (typeof ytTracker !== 'undefined') {
        if (typeof ytTracker.init === 'function') {
            ytTracker.init();
        }
    } else {
        console.log('no ytTracker found'); // eslint-disable-line no-console
    }
}

function loadExternalVideos(videos) {
    $.getScript('https://www.youtube.com/iframe_api', function() {
        let count = 0;
        videos.each(function() {
            const $currentElement = $(this);
            const ytId = $currentElement.attr('src-yt');
            let ytVideo = null;
            const currCount = count;

            function playYtVideo() {
                if (ytVideo !== null) {
                    ytVideo.playVideo();
                } else {
                    initYtVideo();
                }
                $currentElement.parent().addClass('playing');
                $(window).trigger('videoPlaying', [currCount]);
            }

            function stopYtVideo() {
                if (ytVideo !== null) {
                    ytVideo.pauseVideo();
                    $currentElement.parent().removeClass('playing');
                    $(window).trigger('videoStopped', [currCount]);
                }
            }

            function showMedia($element) {
                /*
                    if (!$element.is('iframe')) {
                        $currentElement.after($element);
                    }
                */
                callYtTracker();
            }

            function initYtVideo() {
                $currentElement.after($('<div id="yt' + currCount + '"></div>'));

                const playerVars = {
                    autoplay: 1,
                    controls: 1,
                    rel: 0,
                    showinfo: 0,
                    modestbranding: 1,
                    wmode: 'transparent'
                };

                ytVideo = new YT.Player('yt' + currCount, {
                    width: 1280,
                    height: 720,
                    videoId: ytId,
                    playerVars: playerVars,
                    events: {
                        onStateChange: function(event) {
                            if (event.data === 1) {
                                playYtVideo();
                            }
                            if (event.data === 2) {
                                stopYtVideo();
                            }
                        },
                        onReady: function(event) {
                            showMedia($(event.target.f));
                        }
                    }
                });
            }

            $currentElement.parent().on('click', playYtVideo);

            $(window).on('videoStop', function(e, id) {
                stopYtVideo();
            });

            $(window).on('videoPlaying', function(e, id) {
                if (id !== currCount) {
                    stopYtVideo();
                }
            });

            count++;
        });
    });
}

function playExternalBackgroundVideos(videos) {
    videos.each(function(index, element) {
        element.playVideo();
    });
}

function stopAllVideo() {
    $(window).trigger('videoStop');
}

function hasVideo() {
    return videoOnPage;
}

function init() {
    if (externalVideos.length < 1) return false;
    videoOnPage = true;
    loadExternalVideos(externalVideos);
}

export default {
    init: init,
    hasVideo: hasVideo,
    stopAllVideo: stopAllVideo
};
